// extracted by mini-css-extract-plugin
export default {"content":"style_content__X82xJ","itemName":"style_itemName__cIvDb","leftSide":"style_leftSide__frojw","rightSide":"style_rightSide__AwjKU","type":"style_type__YC0Zw"};